import { useRef } from 'react';
import { MenuButton, MenuGroup, MenuLink, MenuSeparator } from '@frameio/vapor';
import { IconCustomFieldLink, IconMailRead } from '@frameio/vapor-icons';
import type {
  NotificationsActionCallback,
  NotificationsActionContext,
} from '../types';
import TEXT from './generated/TEXT/SecureReviewerContextMenuContent';

TEXT.DEFINE({
  /** Menu item to open link in a new tab */
  labelOpenInNewTab: 'Open in New Tab',
  /** Menu item to mark notification as read */
  markAsRead: 'Mark as Read',
  /** Menu item to mark notification as unread */
  markAsUnread: 'Mark as Unread',
});

type SecureReviewerContextMenuContentProps = {
  href: string;
  onNewTabLinkClick: ({ context }: NotificationsActionCallback) => void;
  isRead: boolean;
  updateNotificationsReadStatus: ({
    context,
  }: NotificationsActionCallback) => void;
};

const ACTION_CONTEXT: NotificationsActionContext = 'context-menu';

export const SecureReviewerContextMenuContent = ({
  href,
  onNewTabLinkClick,
  isRead,
  updateNotificationsReadStatus,
}: SecureReviewerContextMenuContentProps) => {
  const localIsRead = useRef(isRead);

  return (
    <MenuGroup>
      <MenuButton
        data-testid="secure-reviewer-notification-cell-context-menu--toggle-read"
        iconBefore={<IconMailRead />}
        onClick={() =>
          updateNotificationsReadStatus({ context: ACTION_CONTEXT })
        }
      >
        {localIsRead.current ? TEXT.markAsUnread : TEXT.markAsRead}
      </MenuButton>

      <MenuSeparator />

      <MenuLink
        data-testid="notification-cell-context-menu--open-in-new-tab"
        href={href}
        iconBefore={<IconCustomFieldLink />}
        onClick={() => onNewTabLinkClick({ context: ACTION_CONTEXT })}
        rel="noopener noreferrer"
        target="_blank"
      >
        {TEXT.labelOpenInNewTab}
      </MenuLink>
    </MenuGroup>
  );
};
